module.exports = __webpack_public_path__ + "static/img/1-2.4ecda6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/1-2.png
// module id = 6uRt
// module chunks = 0